import { Injectable } from '@angular/core';
import { FormExtractorService } from '../../../../../shared/services/form-extractor.service';
import { RadioCheckBoxEnum } from '../../../../common/radio.checkbox.enums';
import { FormMapaATControlNames } from '../../formMapaATControlNames';
import { CriterePondere } from '../../models/CriterePondere';
import { TypeCrJugement } from '../../models/TypeCrJugement';

@Injectable({
    providedIn: 'root'
})
export class CriteresAttributionService {

    constructor() { }

    setValueFromControlName(value: any, attribut: any[]) {
        if (value && value != '') {
            attribut[attribut.length++] = value;
        }
    }

    public getCriteresAttribution(controls: Map<any, any>, formExtractorService: FormExtractorService): TypeCrJugement {
        const criterePondere_iters = formExtractorService.getIndexes(Array.from(controls.keys()), ['SepSep_CriterePondere'], '_SepSep_AttributionFromMAPA_SepSep_TypeCrJugement_index_');
        let criterePondere_iter = 0;
        const criteresAttribution = new TypeCrJugement();

        switch (controls.get('_SepSep_AttributionFromMAPA_SepSep_TypeCrJugement_SepAtt_critereCDC')) {
            case RadioCheckBoxEnum.critereCdc:
                criteresAttribution.critereCDC = RadioCheckBoxEnum.emptyValue;
                criteresAttribution.critereLibre = null;
                criteresAttribution.criterePondere = null;
                criteresAttribution.criterePrix = null;
                criteresAttribution.typeCritere = RadioCheckBoxEnum.critereCdc;
                break;
            case RadioCheckBoxEnum.criterePondere: criteresAttribution.criterePondere = [];
                criterePondere_iters.forEach(() => {
                    criteresAttribution.criterePondere[criterePondere_iter] = new CriterePondere();

                    criteresAttribution.criterePondere[criterePondere_iter].criterePCT = controls.get('_SepSep_AttributionFromMAPA_SepSep_TypeCrJugement_index_' + (Number(criterePondere_iter + 1)) + '_SepSep_CriterePondere_SepAtt_criterePCT');
                    criteresAttribution.criterePondere[criterePondere_iter].critere = controls.get('_SepSep_AttributionFromMAPA_SepSep_TypeCrJugement_index_' + (Number(criterePondere_iter + 1)) + '_SepSep_CriterePondere_SepAtt_critere');
                    criterePondere_iter++;
                });
                criteresAttribution.critereLibre = null;
                criteresAttribution.critereCDC = null;
                criteresAttribution.criterePrix = null;
                criteresAttribution.typeCritere = RadioCheckBoxEnum.criterePondere;
                break;
            case RadioCheckBoxEnum.critereLibre:
                criteresAttribution.critereLibre = controls.get(FormMapaATControlNames.critereLibre);
                criteresAttribution.criterePondere = null;
                criteresAttribution.critereCDC = null;
                criteresAttribution.criterePrix = null;
                criteresAttribution.typeCritere = RadioCheckBoxEnum.critereLibre;
                break;
                case RadioCheckBoxEnum.criterePrix: 
                criteresAttribution.criterePrix = RadioCheckBoxEnum.emptyValue;
                criteresAttribution.criterePondere = null;
                criteresAttribution.critereCDC = null;
                criteresAttribution.critereLibre = null;
                criteresAttribution.typeCritere = RadioCheckBoxEnum.criterePrix;
                break;
              default:
                criteresAttribution.criterePrix = null;
                criteresAttribution.criterePondere = null;
                criteresAttribution.critereCDC = null;
                criteresAttribution.critereLibre = null;
                criteresAttribution.typeCritere = RadioCheckBoxEnum.emptyValue;
                break;
            }

        return criteresAttribution;
    }
}
